import { render, staticRenderFns } from "./SectorInfoCard.vue?vue&type=template&id=0ae3cb83"
import script from "./SectorInfoCard.vue?vue&type=script&lang=js"
export * from "./SectorInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports